  <!-- Login logo -->
<div class="login">
  <div class="logo">
    <picture>
      <source srcset="/assets/img/uefa-logo-hires.png" media="(max-width: 768px)">
      <source srcset="/assets/img/uefa-logo-hires@2x.png" media="(max-width: 2999px) and (min-width: 769px)">
      <source srcset="/assets/img/uefa-logo-hires@3x.png" media="(min-width: 3000px)">
      <img alt="uefa logo" src="/assets/img/uefa-logo-hires.png" class="uefa-logo-hires">
    </picture>
  </div>

    <!-- Login form -->
  <div class="form">
    <div *ngIf="isAuthenticating" class="authenticating-loader">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p>Logging you in, please wait...</p>
    </div>
  </div>
</div>
